<template>
  <div>
    <div class="bg-gray-900 p-6 rounded-2xl shadow space-y-6 max-w-3xl mx-auto">
      <h1 class="text-2xl font-bold mb-6">Edit Opportunity</h1>
        <form @submit.prevent="updateOpp" class="space-y-4">
        <!-- Title -->
        <div>
          <label class="block text-sm mb-1">Title</label>
          <input v-model="form.title" type="text" :class="classes.input" />
        </div>

        <!-- Organization -->
        <div>
          <label class="block text-sm mb-1">Organization</label>
          <input v-model="form.organization" type="text" :class="classes.input"  />
        </div>

        <!-- Location -->
        <div>
          <label class="block text-sm mb-1">Location</label>
          <input v-model="form.location" type="text" :class="classes.input"  />
        </div>

        <!-- Category -->
        <div>
          <label class="block text-sm mb-1">Category</label>
          <select v-model="form.category" :class="classes.input" id="opportunity_category">
            <option :value="item.key" v-for="item in categories" :key="item.key" v-html="item.name" />
          </select>
        </div>

        <!-- Mode -->
        <div>
          <label class="block text-sm mb-1">Mode</label>
          <select v-model="form.mode" :class="classes.input" >
            <option value="in-person">In-Person</option>
            <option value="virtual">Virtual</option>
            <option value="hybrid">Hybrid</option>
          </select>
        </div>

        <!-- Deadline -->
        <div>
          <label class="block text-sm mb-1">Deadline</label>
          <input v-model="form.deadline" type="date" :class="classes.input"  />
        </div>
        <!-- Tags -->
        <div>
          <label class="block text-sm mb-1">Tags (comma separated)</label>
          <input v-model="tagsInput" type="text" :class="classes.input"  />
        </div>
        <!-- Description -->
        <div>
          <label class="block text-sm mb-1">Description</label>
          <textarea v-model="form.description" rows="5" :class="classes.input"  />
        </div>

        <!-- Link -->
        <div>
          <label class="block text-sm mb-1">Apply Link</label>
          <input v-model="form.link" type="url" :class="classes.input"  />
        </div>

        <div class="pt-4">
          <primary-button class="w-full">Update Opportunity</primary-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import PrimaryButton from '@/components/button/PrimaryButton.vue'
  import { getAllCategories } from '@/utils/category'
  import { getOpportunityById, updateOpportunity } from '@/utils/opportunity'

  const router = useRouter()
  const route = useRoute()
  const classes = ref({
    input: 'w-full p-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring focus:ring-blue-500'
  })

  const form = ref({
    id: '',
    title: '',
    organization: '',
    location: '',
    category: '',
    mode: '',
    description: '',
    tags: [],
    deadline: '',
    link: '',
  })
  const categories = ref([])
  const tags = ref({})
  const tagsInput = ref('')

  const explodeTags = () => {
    form.value.tags = tagsInput.value.split(',').map(tag => tag.trim())
    return true
  }

  const populateForm = async (id) => {
    const data = await getOpportunityById(id)
    if (!data) return router.push('/admin/opportunities')
    form.value = { ...data }
    tags.value = [...form.value.tags]
    if (tags.value)
    {
      tagsInput.value = form.value.tags.map(item => item.name)
    }
    form.value.category = form.value.category?.category_key ?? 'academic-research'
  }

  const updateOpp = async () => {
    explodeTags()
    const result = await updateOpportunity(form.value)
    if (result === true) {
      router.push('/admin/opportunities')
    } else {
      alert('Failed to update opportunity')
    }
  }

  onMounted(async () => {
    categories.value = await getAllCategories()
    await populateForm(route.params.id)
  })
</script>